export default {
  account: {
    settingBtn: 'Account Settings',
    submitBtn: 'Save',
    cancelBtn: 'Cancel',
    uploadSuccess: 'Upload Success',
    submitSuccess: 'Save Success',
    formLabel: {
      account: 'Username',
      photo: 'Icons',
      source: 'Main shop',
      email: 'Email',
      time: 'Expiration date',
    },
  },
  password: {
    subBtnText: 'OK',
    cancelBtnText: 'Cancel',
    pwdMsg: 'Inconsistent with the last password you entered.',
    oldPassword: 'Previous Password',
    oldPasswordMsg: 'Old Password',
    newPassword: 'New password',
    newPasswordMsg: 'New password',
    pw2: 'Confirm the new password',
    passwordTitle: 'Change the password'
  },
};
